import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntBasicHB } from "../../../../../models/handBooks/basicHB";
import {
  useAddRawMaterialMutation,
  useDeleteRawMaterialMutation,
  useEditRawMaterialMutation
} from "../../../../../redux/api/handBooksApi/organic/rawMaterialApi";

const useRawMaterial = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;

  const [addRawMaterial] = useAddRawMaterialMutation();
  const [deleteRawMaterial] = useDeleteRawMaterialMutation();
  const [editRawMaterial] = useEditRawMaterialMutation();

  async function onAddRawMaterial(newRawMaterial: EntBasicHB): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addRawMaterial(newRawMaterial).then((response: any) => {
		if (response.error !== undefined) {

		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onDeleteRawMaterial(rawMaterial: EntBasicHB) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteRawMaterial(rawMaterial.id).then((response: any) => {
			if (response.error !== undefined && response.error.status === 400) {
			  status = false;
			  throw new Error(response.error.data.message);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({ title: t('msg.successDelete') });
			  if (refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };

  async function onEditRawMaterial(editedRawMaterial: EntBasicHB): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editRawMaterial(editedRawMaterial).then((response: any) => {
		if (response.error !== undefined && response.error.status === 400) {
		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({ title: t('msg.successEdited') });
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };
  return { onAddRawMaterial, onDeleteRawMaterial, onEditRawMaterial }

}
export { useRawMaterial };

